import MyFamilyIcon from "assets/menu-icons/MyFamilyIcon";

const myFamily = {
  id: 'group-myFamily',
  type: 'group',
  restricted: false,
  visible: true,
  children: [
    {
      id: 'myFamily',
      title: 'Моя семья',
      type: 'item',
      url: 'myFamily',
      icon: MyFamilyIcon,
      breadcrumbs: false,
      restricted: false,
    },
  ]
};

export default myFamily;
